import React, { useContext, useState } from "react";
import { AppContext } from "./index";
import { diaMes, sizeCelda, sizeCabezal, bkCeldaGrilla, clCeldaGrilla, bkCabGrilla, clCabGrilla, bbottomGrilla } from "./general.js";
import { LogIncidente } from "./contexto/ClasesGrales";
import Boton from "./Boton.js";

export default function LogIncidentes({ incidente }) {
  let { firebase, usrLogged } = useContext(AppContext);

  const [log, setLog] = useState(new LogIncidente(incidente.id, usrLogged.id));
  const [change, setChange] = useState(false)

  function actualizarLogIncidente() {
    firebase.actualizarLogIncidente(log);
    setLog(new LogIncidente(incidente.id, usrLogged.id));
    setChange(false)
  }

  if (incidente.id !== "...nuevo...") {
    return (
      < div style={SlogIncidente} >
        <CabezalLog />
        <div style={SlogInc}>
          {firebase.logIncidente(incidente.id).map((l, x) => (
            <div style={Slog} key={x}>
              <div style={Scelda}>{diaMes(l.fecha)}</div>
              <div style={Scelda}>{l.log}</div>
              <div style={SceldaR}>
                <img
                  src={firebase.usuario(l.responsable).url}
                  alt="?"
                  height="25px"
                  width="25px"
                  style={{ clipPath: "circle(50%)", marginRight: "10px" }}
                ></img>
                <div>{firebase.usuario(l.responsable).nombre}</div>
              </div>
            </div>
          ))}
        </div>
        <textarea
          style={SInputD}
          value={log.log}
          onChange={(e) => {
            e.persist();
            setChange(true)
            setLog((l) => ({ ...l, log: e.target.value }));
          }}
        ></textarea>
        <Boton accion={actualizarLogIncidente} change={change} />
      </div >
    )
  } else return null
}

function CabezalLog() {
  return (
    <div style={Scabezal}>
      <div style={ScabLog}>
        <div>Fecha</div>
        <div>Log de acciones</div>
        <div>Responsable</div>
      </div>
    </div>
  );
}

const SlogIncidente = {
  width: "47%",
};

const Scabezal = {
  fontSize: sizeCabezal,
  fontWeight: "700",
  background: bkCabGrilla,
  color: clCabGrilla,
  padding: "8px 0px 8px 0px",
};

const ScabLog = {
  display: "grid",
  gridTemplateColumns: "9% 68% 23%",
  marginLeft: "5px",
};

const Slog = {
  display: "grid",
  gridTemplateColumns: " 9% 68% 23%",
  marginBottom: "2px",
};

const SlogInc = {
  maxHeight: "55.3vh",
  overflowY: "auto",
  marginTop: "6px"
};

const Scelda = {
  borderBottom: bbottomGrilla,
  padding: "8px 2px 8px 2px",
  fontSize: sizeCelda,
  background: bkCeldaGrilla,
  color: clCeldaGrilla
};

const SceldaR = {
  borderBottom: bbottomGrilla,
  padding: "2px",
  fontSize: sizeCelda,
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  background: bkCeldaGrilla,
  color: clCeldaGrilla
};

const SInputD = {
  width: "100%",
  height: "13vh",
  border: "2px",
  padding: "10px 0px 6px 6px",
  fontSize: sizeCelda,
  margin: "15px 3px 3px 0px",
  borderRadius: "5px",
  resize: "none",
  background: "#E6E6E6",
};
